import { IResource } from "./resource";
import { IResourceCategory } from "./resourceCategory";

export interface IResourcePageResult {
  data: IResource;
  meta: any;
}

export interface IResourceCategoryResult {
  data: IResourceCategory[];
  meta: any;
}

export type IResourcePageAttrAndResourcesQuery = [
  IResourcePageResult,
  IResourceCategoryResult
];

export const ITypeOfResourceArr = [
  "all",
  "video",
  "installation",
  "download",
  "white_paper",
];

export type IResourceLabelType =
  | "all"
  | "video"
  | "installation"
  | "download"
  | "white_paper";
export interface IResourceType {
  value: IResourceLabelType;
  label: "All" | "Video" | "Installation" | "Download" | "White Paper";
}

export const ResourceType: IResourceType[] = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "video",
    label: "Video",
  },
  {
    value: "installation",
    label: "Installation",
  },
  {
    value: "download",
    label: "Download",
  },
  {
    value: "white_paper",
    label: "White Paper",
  },
];
